module.exports = __webpack_public_path__ + "assets/img/stats-small.80587a44.jpg";